// src/features/orders/components/OrderListEmptyState.tsx

export function OrderListEmptyState() {
  return (
    <p className="px-5 py-6 text-center text-sm text-[var(--vania-colors-text-secondary,#a3aab8)]">
      فهرست سفارش‌ها پس از یکپارچه‌سازی با Core Orders در دسترس خواهد بود.
    </p>
  );
}
